import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { InventoryService } from "src/app/services/inventory.service";
import { Component, Inject, OnDestroy, OnInit } from "@angular/core";
import { Subject, takeUntil } from "rxjs";

@Component({
  selector: "app-tooltip-dialog",
  templateUrl: "./tooltip-dialog.component.html",
  styleUrls: ["./tooltip-dialog.component.scss"],
})
export class TooltipDialogComponent implements OnInit,OnDestroy {
  breakdown: StockBreakdown[];
  private destroy$ = new Subject<void>();
  constructor(
    private inventoryService: InventoryService,
    @Inject(MAT_DIALOG_DATA) public data,
    public dialogRef: MatDialogRef<TooltipDialogComponent>
  ) {}

  ngOnInit(): void {
    if(!this.data.Type){
      this.inventoryService.GetStockBreakdown(this.data).pipe(takeUntil(this.destroy$)).subscribe((res: StockBreakdown[]) => {
        this.breakdown = res;
      });
    }    
  }
  
  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }
}

interface StockBreakdown {
  vendorName: string;
  localStock: number;
  vendorItemName: string;
  price: number;
}
